import {chunkString} from '../../../string';

export const bitsToSchedule = (bits: string): string => {
  const bytes = chunkString(bits, 8);

  return bytes
    .map(byte => parseInt(byte, 2).toString(16).padStart(2, '0'))
    .join('');
};
